module.exports = __webpack_public_path__ + "static/media/bhavine_event.a1543b2a.jpg";